(function () {
  'use strict';

  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function renderMoneyFormat(cents, format) {
    format = format || '${{amount}}';
    function build(precision, thousands, decimal) {
      var num = (Math.round(cents) / 100).toFixed(precision);
      var parts = num.split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? intPart + decimal + parts[1] : intPart;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
      switch (name) {
        case 'amount':
          return build(2, ',', '.');
        case 'amount_with_comma_separator':
          return build(2, '.', ',');
        case 'amount_with_space_separator':
          return build(2, ' ', ',');
        case 'amount_no_decimals':
          return build(0, ',', '.');
        case 'amount_no_decimals_with_comma_separator':
          return build(0, '.', ',');
        case 'amount_no_decimals_with_space_separator':
          return build(0, ' ', ',');
        default:
          return build(2, ',', '.');
      }
    });
  }

  function formatMoney(cents, format) {
    var moneyFormat =
      format ||
      (typeof Shopify !== 'undefined' && Shopify.money_format) ||
      '${{amount}}';
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return renderMoneyFormat(cents, moneyFormat);
  }

  function dispatchCartUpdate(cart, variantId, itemCount) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: variantId,
          data: {
            source: 'product-form-component',
            itemCount: itemCount,
            variantId: variantId
          }
        }
      })
    );
  }

  /* —— Gallery (scroll-snap, Glooshe-style fluid swipe) —— */
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  class ProductMainGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-pm-slides]');
      this.slides = Array.from(this.querySelectorAll('[data-pm-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-pm-thumb]'));
      this.prevBtn = this.querySelector('[data-pm-prev]');
      this.nextBtn = this.querySelector('[data-pm-next]');
      this.activeIndex = 0;
      this._dragging = false;
      this._scrollSyncTimer = null;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.activeIndex - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.activeIndex + 1));

      this.thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => this.goTo(i));
      });

      var badge = this.querySelector('[data-pm-social-badge]');
      if (badge) {
        setTimeout(function () {
          badge.classList.add('is-visible');
        }, 2500);
        var closeBtn = badge.querySelector('[data-pm-close-badge]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            badge.classList.remove('is-visible');
            setTimeout(function () {
              badge.style.display = 'none';
            }, 600);
          });
        }
      }

      var activeMedia = this.getAttribute('data-active-media');
      var initialIndex = 0;
      if (activeMedia) {
        var found = this.slides.findIndex(function (s) {
          return s.getAttribute('data-media-id') === activeMedia;
        });
        if (found >= 0) initialIndex = found;
      }

      this.bindScrollSync();
      this.bindDrag();
      var self = this;
      requestAnimationFrame(function () {
        self.goTo(initialIndex, true);
      });
      this.preloadImages();
    }

    bindScrollSync() {
      var self = this;
      if (!this.track) return;

      this.track.addEventListener(
        'scroll',
        function () {
          if (self._dragging) return;
          clearTimeout(self._scrollSyncTimer);
          self._scrollSyncTimer = setTimeout(function () {
            self.syncFromScroll(false);
          }, 50);
        },
        { passive: true }
      );
    }

    syncFromScroll(silent) {
      if (!this.track || !this.slides.length) return;

      var width = this.track.clientWidth;
      if (!width) return;

      var index = Math.round(this.track.scrollLeft / width);
      index = Math.max(0, Math.min(index, this.slides.length - 1));

      if (index !== this.activeIndex) {
        this.setActiveIndex(index, silent);
      }
    }

    bindDrag() {
      var self = this;
      var track = this.track;
      if (!track || this.slides.length <= 1) return;

      var dragging = false;
      var startX = 0;
      var startScrollLeft = 0;
      var lastX = 0;
      var lastTime = 0;
      var velocity = 0;

      track.querySelectorAll('img.pm-gallery__img').forEach(function (img) {
        img.addEventListener('dragstart', function (e) {
          e.preventDefault();
        });
      });

      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        dragging = true;
        self._dragging = true;
        track.classList.add('is-dragging');
        startX = e.pageX;
        startScrollLeft = track.scrollLeft;
        lastX = e.pageX;
        lastTime = Date.now();
        velocity = 0;
        e.preventDefault();
      });

      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        var dx = e.pageX - startX;
        track.scrollLeft = startScrollLeft - dx;
        var now = Date.now();
        var dt = now - lastTime;
        if (dt > 0) {
          velocity = (e.pageX - lastX) / dt;
        }
        lastX = e.pageX;
        lastTime = now;
      });

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        self._dragging = false;
        track.classList.remove('is-dragging');

        var width = track.clientWidth;
        if (!width) return;

        var current = track.scrollLeft / width;
        var target = Math.round(current);

        if (Math.abs(velocity) > 0.35) {
          target = velocity < 0 ? Math.ceil(current) : Math.floor(current);
        }

        target = Math.max(0, Math.min(target, self.slides.length - 1));
        self.goTo(target);
      }

      window.addEventListener('mouseup', endDrag);
    }

    preloadImages() {
      this.slides.forEach(function (slide) {
        slide.querySelectorAll('img.pm-gallery__img').forEach(function (img) {
          img.loading = 'eager';
          if (img.complete) return;
          if (img.decode) {
            img.decode().catch(function () {});
          }
        });
      });
    }

    setActiveIndex(index, silent) {
      this.activeIndex = index;

      this.slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });

      this.thumbs.forEach(function (thumb, i) {
        var isActive = i === index;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });

      if (!silent) {
        this.dispatchEvent(
          new CustomEvent('pm:gallery:change', {
            bubbles: true,
            detail: {
              index: index,
              mediaId: this.slides[index].getAttribute('data-media-id')
            }
          })
        );
      }
    }

    goTo(index, silent) {
      if (!this.slides.length || !this.track) return;

      if (index < 0) index = this.slides.length - 1;
      if (index >= this.slides.length) index = 0;

      var slide = this.slides[index];
      var instant = silent || prefersReducedMotion();
      var left = slide.offsetLeft;

      if (instant) {
        this.track.scrollLeft = left;
      } else {
        this.track.scrollTo({
          left: left,
          behavior: 'smooth'
        });
      }

      this.setActiveIndex(index, silent);
    }

    goToMediaId(mediaId) {
      var idx = this.slides.findIndex(function (s) {
        return s.getAttribute('data-media-id') === mediaId;
      });
      if (idx >= 0) this.goTo(idx);
    }
  }

  if (!customElements.get('product-main-gallery')) {
    customElements.define('product-main-gallery', ProductMainGallery);
  }

  /* —— Ideal for modals —— */
  if (!window.__pmIdealForBound) {
    window.__pmIdealForBound = true;

    function closeIdealPopups() {
      document.querySelectorAll('[data-pm-ideal-popup].is-open').forEach(function (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
      });
      document.body.classList.remove('pm-ideal-for-locked');
    }

    function resetIdealTabs(popup) {
      if (!popup || !popup.classList.contains('pm-ideal-for__popup--tabbed')) return;
      var firstTab = popup.querySelector('[data-pm-ideal-tab]');
      if (firstTab) switchIdealTab(popup, firstTab.getAttribute('data-pm-ideal-tab'));
    }

    function switchIdealTab(popup, tabId) {
      if (!popup || !tabId) return;
      popup.querySelectorAll('[data-pm-ideal-tab]').forEach(function (tab) {
        var isActive = tab.getAttribute('data-pm-ideal-tab') === tabId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      popup.querySelectorAll('[data-pm-ideal-panel]').forEach(function (panel) {
        var isActive = panel.getAttribute('data-pm-ideal-panel') === tabId;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    document.addEventListener('click', function (e) {
      var tabBtn = e.target.closest('[data-pm-ideal-tab]');
      if (tabBtn) {
        e.preventDefault();
        var tabPopup = tabBtn.closest('[data-pm-ideal-popup]');
        switchIdealTab(tabPopup, tabBtn.getAttribute('data-pm-ideal-tab'));
        return;
      }

      var opener = e.target.closest('[data-pm-ideal-open]');
      if (opener) {
        e.preventDefault();
        closeIdealPopups();
        var id = opener.getAttribute('data-pm-ideal-open');
        var popup = document.getElementById(id);
        if (popup) {
          resetIdealTabs(popup);
          popup.classList.add('is-open');
          popup.setAttribute('aria-hidden', 'false');
          document.body.classList.add('pm-ideal-for-locked');
        }
        return;
      }
      if (e.target.closest('[data-pm-ideal-close]')) {
        var popup = e.target.closest('[data-pm-ideal-popup]');
        if (popup) {
          popup.classList.remove('is-open');
          popup.setAttribute('aria-hidden', 'true');
        }
        document.body.classList.remove('pm-ideal-for-locked');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeIdealPopups();
    });
  }

  /* —— Pro comparison —— */
  document.querySelectorAll('[data-pm-pro-comparison]').forEach(function (root) {
    var trigger = root.querySelector('[data-pm-pro-open]');
    var overlay = root.querySelector('[data-pm-pro-overlay]');
    var sheet = root.querySelector('[data-pm-pro-sheet]');
    var closeBtn = root.querySelector('[data-pm-pro-close]');
    if (!trigger || !sheet) return;

    function open() {
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      sheet.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pm-pro-comparison-locked');
      setTimeout(function () {
        sheet.focus();
      }, 100);
    }

    function close() {
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      sheet.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pm-pro-comparison-locked');
    }

    trigger.addEventListener('click', function () {
      if (root.classList.contains('is-open')) close();
      else open();
    });
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });
  });

  /* —— Bundle —— */
  function initBundle(bundle) {
    var options = bundle.querySelectorAll('[data-pm-bundle-option]');
    var colorOptions = bundle.querySelectorAll('[data-pm-color-option]');
    var successEl = bundle.querySelector('[data-pm-bundle-success]');
    var successText = bundle.querySelector('[data-pm-success-text]');
    var atcBtn = bundle.querySelector('[data-pm-add-to-cart]');
    var totalPriceEl = bundle.querySelector('[data-pm-total-price]');
    var totalCompareEl = bundle.querySelector('[data-pm-total-compare]');
    var atcTextEl = bundle.querySelector('[data-pm-atc-text]');
    var variantInput = document.querySelector('[data-pm-variant-input]');
    var offerVariantPickers = Array.from(bundle.querySelectorAll('[data-pm-offer-variants]'));
    var sectionId = bundle.getAttribute('data-section-id');
    var productName = bundle.getAttribute('data-product-name') || '';
    var unitPrice = parseInt(bundle.getAttribute('data-unit-price'), 10) || 0;
    var compareUnit = parseInt(bundle.getAttribute('data-compare-unit'), 10) || unitPrice;
    var moneyFormat = '${{amount}}';
    var messages = {
      atcText: 'Add to Cart',
      atcNudgeText: 'Add 1 more',
      successQty1: 'Add 1 more to unlock 1 free item.',
      successQty2: 'Select your free item',
      successQty3: 'Congrats! You have got 1 free item.',
      successQty4: 'Select your free item',
      successQty5: 'Congrats! You have got 2 free items.',
      successQty6: 'You have unlocked our best deal. Add more anytime.'
    };
    var option3GiftVariantIds = [];
    var productVariants = [];
    var offerImageUrl = '';

    var configEl = bundle.querySelector('[data-pm-bundle-config]');

    if (configEl) {
      try {
        var config = JSON.parse(configEl.textContent);
        if (config.moneyFormat) moneyFormat = config.moneyFormat;
        if (config.messages) messages = Object.assign(messages, config.messages);
        if (config.offerImageUrl) offerImageUrl = config.offerImageUrl;
        if (Array.isArray(config.option3GiftVariantIds)) {
          option3GiftVariantIds = config.option3GiftVariantIds
            .map(function (id) {
              return Number(id);
            })
            .filter(function (id) {
              return id > 0;
            });
        }
        if (Array.isArray(config.variants)) productVariants = config.variants;
      } catch (e) {
        console.warn('Could not parse bundle config', e);
      }
    }

    function fillTemplate(template) {
      if (!template) return '';
      return String(template).split('[product-name]').join(productName);
    }

    function detectDevicePlatform() {
      var userAgent = navigator.userAgent || '';
      var navigatorPlatform = navigator.userAgentData && navigator.userAgentData.platform
        ? navigator.userAgentData.platform
        : navigator.platform || '';

      if (/android/i.test(userAgent) || /android/i.test(navigatorPlatform)) return 'android';
      if (
        /iPad|iPhone|iPod/i.test(userAgent) ||
        /iOS/i.test(navigatorPlatform) ||
        (navigatorPlatform === 'MacIntel' && navigator.maxTouchPoints > 1)
      ) {
        return 'ios';
      }

      return '';
    }

    function preselectDetectedDevice() {
      var detectedPlatform = detectDevicePlatform();
      if (!detectedPlatform) return;

      bundle.querySelectorAll('[data-pm-device-option]').forEach(function (select) {
        var matchingOption = Array.from(select.options).find(function (option) {
          var normalizedValue = option.value.toLowerCase().replace(/[^a-z0-9]/g, '');
          if (detectedPlatform === 'android') return normalizedValue.indexOf('android') !== -1;
          return normalizedValue === 'ios' || normalizedValue.indexOf('apple') !== -1;
        });

        if (matchingOption && !matchingOption.disabled) {
          select.value = matchingOption.value;
        }
      });
    }

    preselectDetectedDevice();

    var quantities = {};
    var selectedOption = null;
    var giftAddInFlight = false;
    var gallery = document.querySelector('product-main-gallery');
    var selectedProductVariant = null;
    var hasInvalidSelectedVariants = false;

    colorOptions.forEach(function (opt, index) {
      var vid = opt.getAttribute('data-pm-variant-id');
      quantities[vid] = index === 0 ? 1 : 0;
    });

    function getVariantForRow(row) {
      var selectedValues = Array.from(row.querySelectorAll('[data-pm-product-option]')).map(function (select) {
        return select.value;
      });

      return (
        productVariants.find(function (variant) {
          return variant.options.every(function (value, index) {
            return value === selectedValues[index];
          });
        }) || null
      );
    }

    var currentVariantId = variantInput ? Number(variantInput.value) : 0;
    selectedProductVariant =
      productVariants.find(function (variant) {
        return Number(variant.id) === currentVariantId;
      }) ||
      productVariants.find(function (variant) {
        return variant.available;
      }) ||
      productVariants[0] ||
      null;

    if (!colorOptions.length && selectedProductVariant) {
      quantities[String(selectedProductVariant.id)] = 1;
      unitPrice = Number(selectedProductVariant.price) || unitPrice;
      compareUnit = Number(selectedProductVariant.compareAtPrice) || unitPrice;
    }

    function getActiveColorImageUrl() {
      if (offerImageUrl) return offerImageUrl;

      if (selectedProductVariant && selectedProductVariant.imageUrl) {
        return selectedProductVariant.imageUrl;
      }

      var activeUrl = '';
      colorOptions.forEach(function (opt) {
        if (activeUrl) return;
        var vid = opt.getAttribute('data-pm-variant-id');
        if (quantities[vid] > 0) {
          var thumb = opt.querySelector('[data-pm-variant-color-url]');
          if (thumb) activeUrl = thumb.getAttribute('data-pm-variant-color-url') || thumb.getAttribute('src') || '';
        }
      });
      if (!activeUrl && colorOptions.length) {
        var fallback = colorOptions[0].querySelector('[data-pm-variant-color-url]');
        if (fallback) activeUrl = fallback.getAttribute('data-pm-variant-color-url') || fallback.getAttribute('src') || '';
      }
      return activeUrl;
    }

    function updateBundleOptionImages() {
      var url = getActiveColorImageUrl();
      if (!url) return;
      bundle.querySelectorAll('[data-pm-bundle-option-image]').forEach(function (img) {
        img.setAttribute('src', url);
      });
      bundle.querySelectorAll('[data-pm-bundle-feature-image]').forEach(function (img) {
        img.setAttribute('src', url);
      });
      var stickyImg = document.querySelector('[data-pm-sticky-for="' + sectionId + '"] [data-pm-sticky-image]');
      if (stickyImg) stickyImg.setAttribute('src', url);
    }

    function getTotalQty() {
      return Object.values(quantities).reduce(function (a, b) {
        return a + b;
      }, 0);
    }

    function rebuildQuantitiesFromSelectedOffer() {
      var selectedOffer = bundle.querySelector('[data-pm-bundle-option].is-selected');
      var selectedRows = selectedOffer
        ? Array.from(selectedOffer.querySelectorAll('[data-pm-offer-variant-row]'))
        : [];

      quantities = {};
      selectedProductVariant = null;
      hasInvalidSelectedVariants = selectedRows.length === 0;

      selectedRows.forEach(function (row) {
        var variant = getVariantForRow(row);

        if (!variant || !variant.available) {
          hasInvalidSelectedVariants = true;
          return;
        }

        if (!selectedProductVariant) selectedProductVariant = variant;
        quantities[String(variant.id)] = (quantities[String(variant.id)] || 0) + 1;
      });

      if (selectedProductVariant) {
        unitPrice = Number(selectedProductVariant.price) || unitPrice;
        compareUnit = Number(selectedProductVariant.compareAtPrice) || unitPrice;
        if (variantInput) variantInput.value = selectedProductVariant.id;
      }
    }

    function autoSelectBundleOption() {
      var totalQty = getTotalQty();
      var target = null;
      if (totalQty <= 1) target = bundle.querySelector('[data-pm-bundle-option="buy1"]');
      else if (totalQty <= 4) target = bundle.querySelector('[data-pm-bundle-option="buy2"]');
      else target = bundle.querySelector('[data-pm-bundle-option="buy3"]');

      if (target && !target.classList.contains('is-selected')) {
        options.forEach(function (o) {
          o.classList.remove('is-selected');
        });
        target.classList.add('is-selected');
        selectedOption = target.getAttribute('data-pm-bundle-option');
      }
    }

    function updateSuccessMessage() {
      if (!successEl || !successText) return;
      var totalQty = getTotalQty();
      var message = '';
      if (totalQty === 1) message = fillTemplate(messages.successQty1);
      else if (totalQty === 2) message = fillTemplate(messages.successQty2);
      else if (totalQty === 3) message = fillTemplate(messages.successQty3);
      else if (totalQty === 4) message = fillTemplate(messages.successQty4);
      else if (totalQty === 5) message = fillTemplate(messages.successQty5);
      else if (totalQty >= 6) message = fillTemplate(messages.successQty6);

      if (message) {
        successText.textContent = message;
        successEl.removeAttribute('hidden');
      } else {
        successEl.setAttribute('hidden', '');
      }
    }

    function setAtcLoading(loading) {
      if (!atcBtn) return;
      atcBtn.classList.toggle('is-loading', loading);
      if (loading) {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-busy', 'true');
        return;
      }
      atcBtn.removeAttribute('aria-busy');
      updatePricing();
    }

    function updatePricing() {
      var totalQty = getTotalQty();
      var itemsToPayFor = 0;
      var itemsToCompareFor = totalQty;

      if (totalQty === 0) itemsToPayFor = 0;
      else if (totalQty === 1) itemsToPayFor = 1;
      else {
        var groupsOf5 = Math.floor(totalQty / 5);
        var remainingAfter5 = totalQty - groupsOf5 * 5;
        var groupsOf3 = Math.floor(remainingAfter5 / 3);
        var remainingAfter3 = remainingAfter5 - groupsOf3 * 3;
        itemsToPayFor = groupsOf5 * 3 + groupsOf3 * 2 + remainingAfter3;
      }

      var totalPrice = Math.round(unitPrice * itemsToPayFor);
      var totalCompare = Math.round(compareUnit * itemsToCompareFor);

      if (totalPriceEl) totalPriceEl.textContent = formatMoney(totalPrice, moneyFormat);
      if (totalCompareEl) {
        totalCompareEl.textContent = formatMoney(totalCompare, moneyFormat);
        if (totalQty <= 1) totalCompareEl.setAttribute('hidden', '');
        else totalCompareEl.removeAttribute('hidden');
      }

      if (atcBtn) {
        var nudge = totalQty === 2 || totalQty === 4;
        var variantUnavailable = offerVariantPickers.length > 0 && hasInvalidSelectedVariants;
        atcBtn.disabled = nudge || variantUnavailable;
        atcBtn.classList.toggle('is-nudge', nudge);
        if (atcTextEl) {
          atcTextEl.textContent = nudge ? fillTemplate(messages.atcNudgeText) : fillTemplate(messages.atcText);
        }
      }

      if (variantInput) {
        var firstWithQty = Object.entries(quantities).find(function (entry) {
          return entry[1] > 0;
        });
        if (firstWithQty) variantInput.value = firstWithQty[0];
      }
    }

    function qualifiesForOption3Gifts() {
      return getTotalQty() >= 5;
    }

    function addOption3Gifts() {
      if (!qualifiesForOption3Gifts() || !option3GiftVariantIds.length || giftAddInFlight) return Promise.resolve();

      giftAddInFlight = true;
      setTimeout(function () {
        giftAddInFlight = false;
      }, 1200);

      var giftItems = option3GiftVariantIds.map(function (id) {
        return {
          id: id,
          quantity: 1,
          properties: { _quantity_break_gift: 'true' }
        };
      });

      var cartItemsComponent = document.querySelector('cart-items-component');
      var cartSectionId = cartItemsComponent && cartItemsComponent.dataset.sectionId;
      var body = { items: giftItems };
      if (cartSectionId) {
        body.sections = cartSectionId;
        body.sections_url = window.location.pathname;
      }

      return fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        })
        .then(function (cartData) {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cartData,
                sourceId: 'product-main-bundle',
                data: {
                  source: 'product-main-bundle',
                  itemCount: giftItems.length,
                  sections: cartData.sections
                }
              }
            })
          );
          return fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
            return r.json();
          });
        })
        .catch(function (err) {
          console.error('Bundle gift add failed', err);
        });
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        options.forEach(function (o) {
          o.classList.remove('is-selected');
        });
        option.classList.add('is-selected');
        selectedOption = option.getAttribute('data-pm-bundle-option');
        if (offerVariantPickers.length) {
          rebuildQuantitiesFromSelectedOffer();
        } else {
          var bundleQty = parseInt(option.getAttribute('data-total-qty'), 10) || 1;
          colorOptions.forEach(function (colorOpt, index) {
            var variantId = colorOpt.getAttribute('data-pm-variant-id');
            var display = colorOpt.querySelector('[data-pm-variant-qty]');
            if (index === 0) {
              quantities[variantId] = bundleQty;
              if (display) display.textContent = bundleQty;
            } else {
              quantities[variantId] = 0;
              if (display) display.textContent = '0';
            }
          });
        }

        updateSuccessMessage();
        updatePricing();
        updateBundleOptionImages();
      });
    });

    offerVariantPickers.forEach(function (picker) {
      picker.addEventListener('click', function (event) {
        event.stopPropagation();
      });

      picker.querySelectorAll('[data-pm-product-option]').forEach(function (select) {
        select.addEventListener('change', function () {
          var row = select.closest('[data-pm-offer-variant-row]');
          var changedVariant = row ? getVariantForRow(row) : null;

          rebuildQuantitiesFromSelectedOffer();
          if (changedVariant && changedVariant.mediaId && gallery) {
            gallery.goToMediaId(changedVariant.mediaId);
          }

          updateBundleOptionImages();
          updateSuccessMessage();
          updatePricing();
        });
      });
    });

    colorOptions.forEach(function (option) {
      var variantId = option.getAttribute('data-pm-variant-id');
      var minusBtn = option.querySelector('[data-pm-qty-action="decrease"]');
      var plusBtn = option.querySelector('[data-pm-qty-action="increase"]');
      var display = option.querySelector('[data-pm-variant-qty]');
      var colorImage = option.querySelector('[data-pm-color-image]');

      if (minusBtn) {
        minusBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (quantities[variantId] > 0) {
            quantities[variantId]--;
            if (display) display.textContent = quantities[variantId];
            autoSelectBundleOption();
            updateSuccessMessage();
            updatePricing();
            updateBundleOptionImages();
          }
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          quantities[variantId]++;
          if (display) display.textContent = quantities[variantId];
          autoSelectBundleOption();
          updateSuccessMessage();
          updatePricing();
          updateBundleOptionImages();
        });
      }

      if (colorImage && gallery) {
        colorImage.addEventListener('click', function (e) {
          e.stopPropagation();
          var mediaId = option.getAttribute('data-pm-media-id');
          if (mediaId) gallery.goToMediaId(mediaId);
        });
      }
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled || atcBtn.classList.contains('is-loading')) return;
        var items = [];
        Object.entries(quantities).forEach(function (entry) {
          if (entry[1] > 0) {
            items.push({ id: parseInt(entry[0], 10), quantity: entry[1] });
          }
        });
        if (!items.length) return;

        setAtcLoading(true);
        fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw data;
              return data;
            });
          })
          .then(function () {
            return fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
              return r.json();
            });
          })
          .then(function (cart) {
            var count = items.reduce(function (sum, i) {
              return sum + i.quantity;
            }, 0);
            if (qualifiesForOption3Gifts() && option3GiftVariantIds.length) {
              return addOption3Gifts().then(function (updatedCart) {
                dispatchCartUpdate(updatedCart || cart, items[0].id, count + option3GiftVariantIds.length);
              });
            }
            dispatchCartUpdate(cart, items[0].id, count);
          })
          .catch(function (err) {
            console.error('Add to cart failed', err);
          })
          .finally(function () {
            setAtcLoading(false);
          });
      });
    }

    if (options[0]) options[0].click();
    else updatePricing();

    /* Sticky + drawer */
    var sticky = document.querySelector('[data-pm-sticky][data-pm-sticky-for="' + sectionId + '"]');
    var drawer = document.querySelector('[data-pm-drawer][data-pm-drawer-for="' + sectionId + '"]');
    var drawerOverlay = document.querySelector('[data-pm-drawer-overlay][data-pm-drawer-for="' + sectionId + '"]');
    var drawerInitialized = false;

    if (sticky && bundle) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            sticky.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      observer.observe(bundle);

      var stickyOpen = sticky.querySelector('[data-pm-sticky-open]');
      if (stickyOpen && drawer && drawerOverlay) {
        function openDrawer() {
          if (!drawerInitialized) {
            var sourceOptions = bundle.querySelector('.pm-bundle__options');
            var drawerBody = drawer.querySelector('[data-pm-drawer-body]');
            if (sourceOptions && drawerBody) {
              var clone = sourceOptions.cloneNode(true);
              clone.classList.add('pm-bundle__options--clone');
              drawerBody.appendChild(clone);
              clone.querySelectorAll('[data-pm-offer-variants]').forEach(function (clonePicker) {
                clonePicker.addEventListener('click', function (event) {
                  event.stopPropagation();
                });
              });
              clone.querySelectorAll('[data-pm-product-option]').forEach(function (cloneSelect) {
                cloneSelect.addEventListener('change', function () {
                  var cloneOffer = cloneSelect.closest('[data-pm-bundle-option]');
                  var cloneRow = cloneSelect.closest('[data-pm-offer-variant-row]');
                  if (!cloneOffer || !cloneRow) return;

                  var key = cloneOffer.getAttribute('data-pm-bundle-option');
                  var cardNumber = cloneRow.getAttribute('data-card-number');
                  var optionPosition = cloneSelect.getAttribute('data-option-position');
                  var mainSelector =
                    '[data-pm-bundle-option="' +
                    key +
                    '"] [data-card-number="' +
                    cardNumber +
                    '"] [data-option-position="' +
                    optionPosition +
                    '"]';
                  var mainSelect = bundle.querySelector(mainSelector);

                  if (mainSelect) {
                    mainSelect.value = cloneSelect.value;
                    mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                });
              });
              clone.querySelectorAll('[data-pm-bundle-option]').forEach(function (cloneOpt) {
                cloneOpt.addEventListener('click', function () {
                  var key = cloneOpt.getAttribute('data-pm-bundle-option');
                  var mainTarget = bundle.querySelector('[data-pm-bundle-option="' + key + '"]');
                  if (mainTarget) mainTarget.click();
                  clone.querySelectorAll('[data-pm-bundle-option]').forEach(function (otherCloneOpt) {
                    otherCloneOpt.classList.toggle('is-selected', otherCloneOpt === cloneOpt);
                  });
                  closeDrawer();
                  bundle.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
              });
            }
            drawerInitialized = true;
          }
          drawerOverlay.classList.add('is-open');
          drawer.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }

        function closeDrawer() {
          drawerOverlay.classList.remove('is-open');
          drawer.classList.remove('is-open');
          document.body.style.overflow = '';
        }

        stickyOpen.addEventListener('click', openDrawer);
        var drawerClose = drawer.querySelector('[data-pm-drawer-close]');
        if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
        drawerOverlay.addEventListener('click', closeDrawer);
      }
    }
  }

  document.querySelectorAll('[data-pm-bundle]').forEach(initBundle);

  /* —— Videos —— */
  class ProductMainVideos extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-pm-videos-track]');
      this.fill = this.querySelector('[data-pm-videos-fill]');
      this.slides = Array.from(this.querySelectorAll('.pm-videos__slide'));
      this.videos = Array.from(this.querySelectorAll('video'));
      this.dragMoved = false;

      this.videos.forEach(
        function (video) {
          var wrapper = video.closest('[data-pm-video-wrapper]');
          var playBtn = wrapper ? wrapper.querySelector('[data-pm-video-play]') : null;
          var self = this;

          video.addEventListener('play', function () {
            if (wrapper) wrapper.classList.add('is-playing');
          });
          video.addEventListener('pause', function () {
            if (wrapper) wrapper.classList.remove('is-playing');
          });

          if (wrapper) {
            wrapper.addEventListener('click', function () {
              if (self.dragMoved) return;
              if (video.paused) video.play();
              else video.pause();
            });
          }
          if (playBtn) {
            playBtn.addEventListener('click', function (e) {
              e.stopPropagation();
              if (self.dragMoved) return;
              video.play();
            });
          }
        }.bind(this)
      );

      if (this.track && this.fill) {
        this.initTrackScroll();
        this.track.addEventListener('scroll', () => this.updateProgress());
        this.updateProgress();
      }
    }

    initTrackScroll() {
      var track = this.track;
      var self = this;
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;

      track.addEventListener(
        'wheel',
        function (e) {
          if (track.scrollWidth <= track.clientWidth) return;
          if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
          e.preventDefault();
          track.scrollLeft += e.deltaY;
        },
        { passive: false }
      );

      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        isDown = true;
        self.dragMoved = false;
        startX = e.pageX;
        scrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });

      window.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 4) self.dragMoved = true;
        track.scrollLeft = scrollLeft - dx;
        self.updateProgress();
      });

      window.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        window.setTimeout(function () {
          self.dragMoved = false;
        }, 0);
      });
    }

    updateProgress() {
      if (!this.track || !this.fill) return;
      var max = this.track.scrollWidth - this.track.clientWidth;
      var pct = max > 0 ? this.track.scrollLeft / max : 0;
      this.fill.style.width = Math.min(100, pct * 100 + (this.slides.length ? 100 / this.slides.length : 0)) + '%';
    }
  }

  if (!customElements.get('product-main-videos')) {
    customElements.define('product-main-videos', ProductMainVideos);
  }

  /* —— Shipping geo —— */
  document.querySelectorAll('[data-pm-shipping]').forEach(function (el) {
    var thresholdDisplay = el.getAttribute('data-threshold-display') || '';
    var defaultCountry = (el.getAttribute('data-default-country') || 'gb').toLowerCase();
    var useGeo = el.getAttribute('data-use-geo') === 'true';
    var flagImg = el.querySelector('.pm-shipping__flag');
    var textEl = el.querySelector('[id^="pm-shipping-text-"]');

    function setFlag(code) {
      if (!flagImg || !code) return;
      var normalized = String(code).toLowerCase().trim();
      flagImg.src = 'https://flagcdn.com/' + normalized + '.svg';
    }

    function setShippingText() {
      if (!textEl || !thresholdDisplay) return;
      textEl.innerHTML = 'Livraison <strong>OFFERTE</strong> dès ' + thresholdDisplay;
    }

    setFlag(defaultCountry);
    setShippingText();

    if (!useGeo) return;

    fetch('https://get.geojs.io/v1/ip/geo.json')
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.country_code) {
          setFlag(data.country_code);
          if (data.country) {
            flagImg.alt = data.country + ' flag';
          }
        }
      })
      .catch(function () {});
  });
})();
